<template>
    <div class="col">
        <h3>Välkommen</h3>
        <p>Skickas till helt nya kunder.</p>
        <div class="d-flex mt-2 align-items-center">
            <button class="btn btn-primary" :disabled="poster.submitted" @click="posterPost()">
                <span class="spinner-border spinner-border-sm"></span>
                Skicka
            </button>
            <div class="ps-2" v-if="company.email_welcome_sent_at">
                <i>Senast skickat: {{ company.email_welcome_sent_at }}</i>
            </div>
        </div>
    </div>
</template>

<script>
import poster from '../../../../shared/mixins/poster'

export default {

    props: {
        company: {
            required: true
        }
    },

    mixins: [
        poster
    ],

    computed: {
        posterUrl () {
            return '/companies/' + this.company.id + '/sendWelcomeEmail'
        }
    },

    methods: {
        posterSuccess () {
            bus.$emit(
                'notify',
                'Välkomstmail skickat'
            )
            this.$emit('success')
        }
    }
}
</script>
